import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NbButtonModule, NbInputModule, NbCardModule, NbIconModule, NbLayoutModule, NbFormFieldModule } from "@nebular/theme";
import { AuthRoutingModule } from "./auth-routing.module";
import { AuthComponent } from "./auth.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { LoginComponent } from "./login/login.component";
import { ResetComponent } from "./reset/reset.component";
import { WelcomeComponent } from "./welcome/welcome.component";

@NgModule({
    declarations: [
        AuthComponent,
        LoginComponent,
        ForgotComponent,
        ResetComponent,
        WelcomeComponent
    ],
    imports: [
        CommonModule,
        NbLayoutModule,
        NbButtonModule,
        NbInputModule,
        NbCardModule,
        NbIconModule,
        ReactiveFormsModule,
        AuthRoutingModule,
        NbFormFieldModule
    ]
})
export class AuthModule { }
